import { ButtonHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  size?: number;
}

const Styled = styled.button<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: transparent;
  color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid transparent;
  transition: all ${({ theme }) => theme.transitions.base};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.bgMuted};
    color: ${({ theme }) => theme.colors.primary};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ label, size = 36, type = 'button', children, ...rest }, ref) => (
    <Styled
      ref={ref}
      type={type}
      $size={size}
      aria-label={label}
      title={label}
      {...rest}
    >
      {children}
    </Styled>
  ),
);

IconButton.displayName = 'IconButton';
